import styled from 'styled-components';

export const MobileModalTitle = styled.div`
  width: 100%;
  font-family: var(--fontRegular);
  font-size: 14px;
  color: ${props => props.theme.secondaryText};
  height: 45px;
  border-bottom: 1px solid ${props => props.theme.separator};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  button {
    height: 100%;
    position: absolute;
    right: 6px;
    top: 2px;
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
  }
`;

export const MobileModalContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  font-family: var(--fontRegular);
  font-size: 14px;
  text-align: center;
  color: ${props => props.theme.primaryText};
  &:not(:last-of-type) {
    border-bottom: 1px solid ${props => props.theme.separator};
  }
`;
